import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Error404Component } from './views/error404/error404.component';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { MenuGroupGuard } from './guard/menu-group.guard';
import { LandingRedirectGuard } from './guard/landing-redirect.guard';
import { Error403Component } from './views/error403/error403.component';
import { Error500Component } from './views/error500/error500.component';
import { AccountDisabledPageComponent } from './views/account-disabled-page/account-disabled-page.component';
import { NoAccessComponent } from './views/no-access/no-access.component';


const routes: Routes = [
  {
    // Was `redirectTo: '/app'`. A redirect is resolved during route recognition,
    // before guards, so it could never consult the org's pinned landing page.
    // LandingRedirectGuard answers with a UrlTree instead: the pinned landing
    // when the user is signed in and it is visible to them, else '/app' exactly 
    // as before. `children: []` keeps this a component-less route whose only job
    // is to decide where to go. Scoped to the bare root — deep links untouched.
    path: '',
    pathMatch: 'full',
    canActivate: [LandingRedirectGuard],
    children: []
  },
  {
    path: 'app',
    loadChildren: './layouts/app-layout/layout1.module#Layout1Module',
    canActivateChild: [AuthGuard, MenuGroupGuard]
  },
  {
    path: 'auth',
    loadChildren: './layouts/auth-layout/auth-layout.module#AuthLayoutModule'
  },
  {
    path: '403',
    component: Error403Component
  },
  {
    path: '500',
    component: Error500Component
  }, 
  {
    path: 'account-disabled',
    component: AccountDisabledPageComponent
  },
  {
    path: 'no-access',
    component: NoAccessComponent
  },
  { path: '**', component: Error404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
